import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import endpoints from 'constants/endpoints';
import { safePostCall } from 'helpers/firebaseSetup';
import { parseZohoOkMessageOutput } from 'helpers/zoho/response-parsers';
import { showAlert } from 'state/actions/site';

export default function useLeadPartnerApplySubmit() {
  const dispatch = useDispatch();
  const agentId = useSelector(state => state.user.zohoData?.id);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitApplication = useCallback(
    async ({ leadPartnerName, questions }) => {
      if (!agentId) {
        dispatch(
          showAlert({
            message:
              'Unable to resolve your agent profile. Try signing in again.',
            code: 'error'
          })
        );
        return false;
      }

      setIsSubmitting(true);
      try {
        const body = {
          isZohoRequest: true,
          endpoint: endpoints.zoho.createLeadPartnersEntry,
          agentId: String(agentId),
          leadPartnerName,
          questions
        };

        const response = await safePostCall(endpoints.awsProxy.safePost, body);

        if (response?.data?.details?.output) {
          const { ok, message } = parseZohoOkMessageOutput(
            response.data.details.output
          );
          dispatch(
            showAlert({
              message: message || 'Request completed.',
              code: ok ? 'success' : 'error'
            })
          );
          return ok;
        }

        dispatch(
          showAlert({
            message: 'Something went wrong. Try again later.',
            code: 'error'
          })
        );
        return false;
      } catch (e) {
        console.error(e);
        dispatch(
          showAlert({
            message: 'Something went wrong. Try again later.',
            code: 'error'
          })
        );
        return false;
      } finally {
        setIsSubmitting(false);
      }
    },
    [dispatch, agentId]
  );

  return { submitApplication, isSubmitting };
}
